import { isTokenExpired } from './chunk-F2DE7PYR.mjs';
import { useQueryContext } from './chunk-OYSCTTI3.mjs';
import { useAuthContext } from './chunk-K3UDKV2P.mjs';
import { __async, __spreadProps, __spreadValues } from './chunk-4U7ZT42S.mjs';
import { useQuery } from '@tanstack/react-query';
import request from 'graphql-request';

var useRequest = (props) => {
  const {
    queryKey,
    getAccessToken,
    document,
    variables,
    staleTime = 5 * 60 * 1e3,
    enabled = true
  } = props;
  const { isSignedIn, signOut } = useAuthContext();
  const { hasuraUrl } = useQueryContext();
  return useQuery({
    queryKey,
    queryFn: () => __async(null, null, function* () {
      let headers = {
        "content-type": "application/json"
      };
      if (typeof getAccessToken !== "undefined") {
        if (!isSignedIn) {
          signOut();
          throw new Error("Session expired. Please sign in again.");
        }
        try {
          const token = yield getAccessToken();
          if (!token) {
            throw new Error("Invalid access token");
          }
          headers = __spreadProps(__spreadValues({}, headers), {
            Authorization: `Bearer ${token}`
          });
        } catch (error) {
          console.error("Authentication failed:", error);
          throw error;
        }
      }
      try {
        return yield request({
          url: hasuraUrl,
          document: document.toString(),
          requestHeaders: headers,
          variables
        });
      } catch (error) {
        if (isTokenExpired(error)) {
          signOut();
          throw new Error("Session expired. Please sign in again.");
        }
        throw error;
      }
    }),
    staleTime,
    enabled
  });
};

export { useRequest };
//# sourceMappingURL=chunk-SNCLEEAV.mjs.map
//# sourceMappingURL=chunk-SNCLEEAV.mjs.map